
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartn8QY_45fMavvGGY0o6zZ_aDqzFrU9yJggtBeHraigrZAUMeta } from "/builds/andy.c/gsn-frontend/pages/cart.vue?macro=true";
import { default as chatdMCibrwPWhRUG8LsrLeYwT2RgqPIUxuypHuP_I0WY1kMeta } from "/builds/andy.c/gsn-frontend/pages/chat.vue?macro=true";
import { default as homeX6c_45YI960JG8E2mPRvHt_JBYdzL01Pcm6mxBDR_45w9bEMeta } from "/builds/andy.c/gsn-frontend/pages/home.vue?macro=true";
import { default as indexwcUQggnjzWYdjxz35rk1LEsqcdZx5r38npWwtP7_45wWgMeta } from "/builds/andy.c/gsn-frontend/pages/index.vue?macro=true";
import { default as ordery_itppxyG5pZp4mCG_UHbaBGIaoCyWjgZ4wy_VcdCzQMeta } from "/builds/andy.c/gsn-frontend/pages/order.vue?macro=true";
import { default as resultT_pEpHiur_45tb2DlhAwO_zBwULvvUHKH9FE7HhVnxwTkMeta } from "/builds/andy.c/gsn-frontend/pages/result.vue?macro=true";
import { default as paymentqNETGY3HlRzEjE6c7xWDKSQ8DYNwesk2zwXvvkZM_45iQMeta } from "/builds/andy.c/gsn-frontend/pages/payment.vue?macro=true";
import { default as index8QyKxzwrPZvUHKZUpJ882E9BgtrBc0wJMADHLcwkgUUMeta } from "/builds/andy.c/gsn-frontend/pages/Guest/index.vue?macro=true";
import { default as indexHf7ZvXJYKBs1dfLojb_45XfoYX_45Fw_45bL2HaaB0eUf_6Y8Meta } from "/builds/andy.c/gsn-frontend/pages/signup/index.vue?macro=true";
import { default as indexvVsYkFMp6720Jmf6neOxBmf3wxFITcgE0_yOdG_4584TIMeta } from "/builds/andy.c/gsn-frontend/pages/account/index.vue?macro=true";
import { default as processing9wwaQYDaVGG2yuzY4djMn4kKOMUaoSXFooQf5RdNbD0Meta } from "/builds/andy.c/gsn-frontend/pages/auth/processing.vue?macro=true";
import { default as indexpSPrvm_IrwCUJaws4TUcFwfPJXUTiYSx_0DNjCaRh_45AMeta } from "/builds/andy.c/gsn-frontend/pages/resetPassword/index.vue?macro=true";
import { default as indexPffGpcaySyz9nI2OOZXkhSEnoNGarudJSdZFWb9HrkwMeta } from "/builds/andy.c/gsn-frontend/pages/forgetPassword/index.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    meta: cartn8QY_45fMavvGGY0o6zZ_aDqzFrU9yJggtBeHraigrZAUMeta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/cart.vue")
  },
  {
    name: "chat",
    path: "/chat",
    meta: chatdMCibrwPWhRUG8LsrLeYwT2RgqPIUxuypHuP_I0WY1kMeta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/chat.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/builds/andy.c/gsn-frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/andy.c/gsn-frontend/pages/index.vue")
  },
  {
    name: "order",
    path: "/order",
    component: () => import("/builds/andy.c/gsn-frontend/pages/order.vue")
  },
  {
    name: "result",
    path: "/result",
    component: () => import("/builds/andy.c/gsn-frontend/pages/result.vue")
  },
  {
    name: "payment",
    path: "/payment",
    meta: paymentqNETGY3HlRzEjE6c7xWDKSQ8DYNwesk2zwXvvkZM_45iQMeta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/payment.vue")
  },
  {
    name: "Guest",
    path: "/Guest",
    component: () => import("/builds/andy.c/gsn-frontend/pages/Guest/index.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: indexHf7ZvXJYKBs1dfLojb_45XfoYX_45Fw_45bL2HaaB0eUf_6Y8Meta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/signup/index.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/builds/andy.c/gsn-frontend/pages/account/index.vue")
  },
  {
    name: "auth-processing",
    path: "/auth/processing",
    meta: processing9wwaQYDaVGG2yuzY4djMn4kKOMUaoSXFooQf5RdNbD0Meta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/auth/processing.vue")
  },
  {
    name: "resetPassword",
    path: "/resetPassword",
    meta: indexpSPrvm_IrwCUJaws4TUcFwfPJXUTiYSx_0DNjCaRh_45AMeta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/resetPassword/index.vue")
  },
  {
    name: "forgetPassword",
    path: "/forgetPassword",
    meta: indexPffGpcaySyz9nI2OOZXkhSEnoNGarudJSdZFWb9HrkwMeta || {},
    component: () => import("/builds/andy.c/gsn-frontend/pages/forgetPassword/index.vue")
  }
]